import { render, staticRenderFns } from "./BoxHeader.vue?vue&type=template&id=1d5e9c68"
import script from "./BoxHeader.vue?vue&type=script&lang=ts"
export * from "./BoxHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports